<template>
  <naj-box
    :title="basicInfoLocal.requestApplicant.title"
    no-gutters
  >
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <v-row v-else>
      <v-col
        cols="6"
        :md="6"
      >
        <p class="px-5 section-header">
          {{ local.bankruptcy.requestApplicant.personalInfo }}
        </p>
        <info-list
          :form-model="applicantDetails"
          :headers="headers"
        ></info-list>
      </v-col>

      <v-col
        v-if="applicantDetails.attorneyTypeId"
        cols="6"
        :md="6"
      >
        <p class="px-5 section-header">
          {{ local.bankruptcy.lawyerInfo.title }}
        </p>
        <info-list
          :form-model="applicantDetails"
          :headers="attorneyHeaders"
        ></info-list>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';

import { attorneyTypeEnum } from '@/modules/bankruptcy/helpers/enum';
export default {
  name: 'RequestApplicant',
  components: { InfoList },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toHijriDate,
      applicantDetails: {},
      loading: false,
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile.basicInfo,
      headers: [
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestApplicant.fullName,
          size: 12,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestApplicant.socialId,
          size: 12,
        },
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestApplicant.socialIdType,
          size: 12,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestApplicant.birthDate,
          formatter: (val) => { return this.toHijriDate(val) || '---'; },
          size: 12,
        },
        {
          key: 'gender',
          text: this.local.bankruptcy.requestApplicant.gender,
          formatter: (val) => { return val == 1 ? this.local.bankruptcy.genders.male : (val == 2 ? this.local.bankruptcy.genders.female : '---'); },
          size: 12,
        },
        {
          key: 'mobile',
          text: this.local.bankruptcy.requestApplicant.mobileNumber,
          size: 12,
        },
        {
          key: 'email',
          text: this.local.bankruptcy.requestApplicant.email,
          size: 12,
        },
        {
          key: 'nationalityName',
          text: this.local.bankruptcy.requestApplicant.nationality,
          size: 12,
        },
      ],
      attorneyHeaders: [
        {
          key: 'attorneyTypeId',
          text: this.local.bankruptcy.lawyerInfo.attorneyType,
          formatter: (val) => { return val == attorneyTypeEnum.internal ? this.local.bankruptcy.attorneyTypes.internal : this.local.bankruptcy.attorneyTypes.external; },
          size: 12,
        },
        {
          key: 'attorneyNumber',
          text: this.local.bankruptcy.lawyerInfo.attorneyNumber,
          size: 12,
        },
        {
          key: 'isApprovedFromMofa',
          text: this.local.attorney.isApprovedFromMofa,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
          size: 12,
        },
        {
          key: 'isApprovedFromMoj',
          text: this.local.attorney.isApprovedFromMoj,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
          size: 12,
        },
        {
          key: 'externalAttorneySource',
          text: this.local.attorney.source,
          size: 12,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.loading = true;
    this.getMainApplicantDetails(this.requestObjectKey)
      .then((res) => {
        this.applicantDetails = res.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: { ...mapActions(['getMainApplicantDetails']) },
};

</script>

<style lang="scss" scoped>
.section-header {
  color: var(--app-dark-primary-color);
  font: normal normal bold 20px/31px Almarai;
}
</style>
